<script setup lang="ts">
import { onUnmounted, ref, watchEffect } from "vue";
import { tapOutSide$ } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{
  (event: "outSide", e: HammerInput): void;
}>();

const r = ref();

let s;
watchEffect(() => {
  if (!r.value) {
    return;
  }
  s?.unsubscribe();
  s = tapOutSide$(r.value).subscribe((e) => {
    emits("outSide", e);
  });
});

onUnmounted(() => {
  s?.unsubscribe();
});

defineExpose({});
</script>

<template>
  <div
    ref="r"
    class="tap"
    :style="{ display: 'inline-block' }"
  >
    <slot></slot>
  </div>
</template>

<style></style>
